import { render, staticRenderFns } from "./rolesMgt.vue?vue&type=template&id=6ea2b238&"
import script from "./rolesMgt.vue?vue&type=script&lang=js&"
export * from "./rolesMgt.vue?vue&type=script&lang=js&"
import style0 from "./rolesMgt.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports